var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.aoic
    ? _c(
        "div",
        {
          staticClass: "personal-use-item ticket",
          class: { disabled: !_vm.canBeSelected },
        },
        [
          _c(
            "label",
            { staticClass: "personal-use-item--description" },
            [
              _vm.aoic.productId && _vm.event
                ? [
                    _c("p", { staticClass: "ticket__descriptionTitle" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$tm(
                            _vm.findProduct(_vm.aoic.productId),
                            "descriptionWebShop"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "ticket__descriptionSubtitle" }, [
                      _vm._v(_vm._s(_vm.$tm(_vm.event, "descriptionExternal"))),
                    ]),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _vm.slot
            ? [
                _c("div", { staticClass: "personal-use-item--quota" }, [
                  _c("p", { staticClass: "ticket__quotaTitle" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("checkout.personalisation.publicTransport.slot")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm._f("formatTimeString")(
                          _vm.slot.printStart,
                          _vm.userLanguage
                        )
                      ) +
                        " - " +
                        _vm._s(
                          _vm._f("formatTimeString")(
                            _vm.slot.printEnd,
                            _vm.userLanguage
                          )
                        ) +
                        " Uhr"
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("formatDateString")(
                            _vm.slot.printStart,
                            _vm.userLanguage
                          )
                        ) + "\n        "
                      ),
                      new Date(_vm.slot.printStart).getDate() !==
                      new Date(_vm.slot.printEnd).getDate()
                        ? [
                            _vm._v(
                              "\n          - " +
                                _vm._s(
                                  _vm._f("formatDateString")(
                                    _vm.slot.printEnd,
                                    _vm.userLanguage
                                  )
                                ) +
                                "\n        "
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "checkout-form__field checkout-form__field--radio" },
            [
              !_vm.canBeSelected
                ? _c("div", { staticClass: "info-no-personalization-needed" }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm.$t(
                            "checkout.personalisation.personalUseModal.info4"
                          )
                        ) +
                        "\n    "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.canBeSelected
                ? [
                    _c(
                      "label",
                      { attrs: { for: "use-personal-yes-" + _vm.aoic.id } },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.aoic.personalUse,
                              expression: "aoic.personalUse",
                            },
                          ],
                          attrs: {
                            id: "use-personal-yes-" + _vm.aoic.id,
                            name: "use-personal-yes-" + _vm.aoic.id,
                            type: "radio",
                            readonly: !_vm.canBeSelected,
                            disabled: !_vm.canBeSelected,
                          },
                          domProps: {
                            value: true,
                            checked: _vm._q(_vm.aoic.personalUse, true),
                          },
                          on: {
                            change: [
                              function ($event) {
                                return _vm.$set(_vm.aoic, "personalUse", true)
                              },
                              _vm.onChangeSelection,
                            ],
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "radio__checkMark" }),
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("global.forms.yes")) +
                            "\n      "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "label",
                      { attrs: { for: "use-personal-no-" + _vm.aoic.id } },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.aoic.personalUse,
                              expression: "aoic.personalUse",
                            },
                          ],
                          attrs: {
                            id: "use-personal-no-" + _vm.aoic.id,
                            name: "use-personal-no-" + _vm.aoic.id,
                            type: "radio",
                            readonly: !_vm.canBeSelected,
                            disabled: !_vm.canBeSelected,
                          },
                          domProps: {
                            value: false,
                            checked: _vm._q(_vm.aoic.personalUse, false),
                          },
                          on: {
                            change: [
                              function ($event) {
                                return _vm.$set(_vm.aoic, "personalUse", false)
                              },
                              _vm.onChangeSelection,
                            ],
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "radio__checkMark" }),
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("global.forms.no")) +
                            "\n      "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.aoic.personalUse,
                          expression: "aoic.personalUse",
                        },
                      ],
                      attrs: {
                        id: "use-personal-null-" + _vm.aoic.id,
                        hidden: "",
                        name: "use-personal-null-" + _vm.aoic.id,
                        type: "radio",
                      },
                      domProps: {
                        value: null,
                        checked: _vm._q(_vm.aoic.personalUse, null),
                      },
                      on: {
                        change: [
                          function ($event) {
                            return _vm.$set(_vm.aoic, "personalUse", null)
                          },
                          _vm.onChangeSelection,
                        ],
                      },
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }